import axios from 'axios';
import {
  GET_LEAGUE_CARD_DATA_REQUEST,
  GET_LEAGUE_CARD_DATA_SUCCESS,
  GET_LEAGUE_CARD_DATA_FAILURE
} from 'Store/constants';
import errorMessage from './errorMessage';
import queryString from 'query-string';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

/**
 * BFF lig kartı cevabını LeagueCardBroadage ve CardInfoHeader'ın beklediği forma dönüştürür.
 * BFF: { tournamentId, tournamentName, avatarUrl, widgets: { widgets: [{ name, widgetName }] } }
 * Beklenen: { tournament: { name, avatarUrl }, widgets: { widgetTabs: [...], tournamentId } }
 */
function normalizeLeagueCardBffPayload (bffData) {
  if (!bffData) return bffData;
  const widgetList = bffData.widgets?.widgets ?? (Array.isArray(bffData.widgets) ? bffData.widgets : []);
  return {
    ...bffData,
    tournament: {
      name: bffData.tournamentName,
      avatarUrl: bffData.avatarUrl,
      logoUrl: bffData.avatarUrl,
      image: bffData.avatarUrl
    },
    widgets: {
      widgetTabs: widgetList,
      tournamentId: bffData.tournamentId
    }
  };
}

/**
 * v2 lig kartı için sports-data-bff servisi (getFixtureAndStandings).
 */
export const getLeagueCardDataBff = options => async dispatch => {
  const fullUrl = queryString.stringifyUrl({
    url: `${API_GATEWAY}/sports-data/matches/${options.leagueId}/league`,
    query: {
      requestedSeason: options?.requestedSeason,
      requestedWeek: options?.requestedWeek,
    }
  }, { skipNull: true });

  try {
    dispatch({
      type: GET_LEAGUE_CARD_DATA_REQUEST
    });

    const res = await axios.get(fullUrl);
    const payload = normalizeLeagueCardBffPayload(res.data);

    dispatch({
      type: GET_LEAGUE_CARD_DATA_SUCCESS,
      payload
    });

    return payload;
  } catch (e) {
    dispatch({
      type: GET_LEAGUE_CARD_DATA_FAILURE,
      payload: errorMessage
    });

    throw errorMessage;
  }
};
